import { OrdersState } from "../types";

export const ordersStates: Partial<OrdersState> = {
	orders: [],
	waitingOrders: [],
	ordersGroups: [],
	ordersByTable: [],
	orderDetail: null,
	orderInfoDetail: null,
	orderDetailPerson: null,
	orderInfoDetailPerson: null,
	ordersDelayed: [],
	ordersByVisit: [],
	ordersByDate: [],
	ordersByPerson: [],
	ordersWaitingNext: [],
	ordersDelayedNext: [],
	ordersSearchNext: '',
	selectedOrderId: 0,
	selectedOrderInfoId: 0,
	stats: {
		appointments: null,
		participants: null,
	}
}